import React from "react";
import PropTypes from "prop-types";
import { get, chunk } from "lodash";
import { LazyCollection, wrapCollectionLayout, LoadMoreCollectionStories } from "@quintype/components";
import { addAdsToTemplates } from "../../get-collection-template";

import { LoadMoreButton } from "../../atoms/read-more-link";
import { GA, WebEngage, DeepBI, EVOLOK } from "../../../integrations";
import styles from "./styles.m.css";
import { VikatanDesktopSticky, VikatanSticky } from "../../rows/ad-free";

import MyvikatanCollection from "../../rows/myvikatan-collection";
import TweleStoriesCollection from "../../rows/twele-stories-collection";
import MyVikatanHeader from "../../rows/myvikatan-header";
// import Icon from "../../atoms/icon";

const LOAD_MORE_TEXT = "மேலும் படிக்க";

const newTemplates = addAdsToTemplates("section");

function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

const wrapForLoadMore = (Component, numberOfStoriesItCanAccomodate) => {
  const WrapperForLoadMore = ({ stories, collection, onLoadMore, noMoreStories, loading, loadmoregreen }) => {
    return (
      <React.Fragment>
        {chunk(stories.slice(12), numberOfStoriesItCanAccomodate).map((stories, index) => {
          const items = stories.map(story => {
            return { id: story.id, type: "story", story };
          });
          return <Component key={index} collection={{ ...collection, items }} pagetype="section" />;
        })}
        {!noMoreStories &&
          stories.length > numberOfStoriesItCanAccomodate && (
            <div className={styles["load-more-button-wrapper"]}>
              <LoadMoreButton
                onClick={onLoadMore}
                disabled={loading}
                text={LOAD_MORE_TEXT}
                loadmoregreen={loadmoregreen}
                className={styles["loadmoregreen"]}
              />
            </div>
          )}
      </React.Fragment>
    );
  };
  WrapperForLoadMore.propTypes = {
    stories: PropTypes.array,
    collection: PropTypes.object,
    onLoadMore: PropTypes.func,
    noMoreStories: PropTypes.func,
    loading: PropTypes.bool,
    loadmoregreen: PropTypes.bool
  };
  return WrapperForLoadMore;
};

function shouldShowCollectionLayout(collection) {
  const firstCollection = get(collection, ["items"], []).find(item => item.type === "collection");
  return !!firstCollection;
}
export class MyVikatanPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      random: 0
    };
  }

  componentDidMount() {
    const sections = [this.props.data.section];
    if (this.props.data.parentSection) {
      sections.unshift(this.props.data.parentSection);
    }
    GA.registerPageView(this.props.pageType, { section: this.props.data.section });
    WebEngage.registerPageView({ section: this.props.data.section });
    EVOLOK.loadScript(this.props.pageType, { collection: this.props });
    DeepBI.registerPageView({ collection: this.props });
  }

  render() {
    const stories = get(this.props.data, ["collection", "items"], []);

    const sectionSlug = get(this.props.data, ["collection", "slug"], "");
    const section = get(this.props.data, ["section"], {});

    const sectionColor = get(section, ["data", "color"], "#2c2c2c");
    const pageType = get(this.props, ["pageType"], null);

    if (stories.length < 1) {
      return (
        <div className={styles["default-section-page"]}>
          <div className={styles["no-stories"]}>
            <h2 className={styles["no-stories-status"]}>No stories found.</h2>
          </div>
        </div>
      );
    }
    if (shouldShowCollectionLayout(this.props.data.collection)) {
      const collectionItems = get(this.props.data, ["collection", "items"], []).filter(
        items => items.type === "collection"
      );
      const collection = { ...this.props.data.collection, items: [...collectionItems] };

      return (
        <div className={`${styles["default-section-page"]} ${styles["default-section-page-container"]}`}>
          <div className={styles["section-page"]}>
            <div
              className={
                sectionSlug === "cricket-world-cup-2023" ? styles["cricket-collection"] : styles["first-collection"]
              }
            >
              <LazyCollection
                collection={collection}
                collectionTemplates={getAdsWrappedCollectionTemplate}
                lazyAfter={4}
                accentColor={sectionColor}
                pageType={pageType}
              />
            </div>
          </div>
          <VikatanSticky placement="bundle" />
        </div>
      );
    }
    const initialStories = get(this.props.data, ["collection", "items"], []).filter(items => items.type === "story");
    const WrappedFourStoryOneAdOneWidget = wrapCollectionLayout(MyvikatanCollection);

    return (
      <div className={`${styles["default-section-page"]} ${styles["default-section-page-container"]}`}>
        <div className={styles["section-page"]}>
          <div className={`${styles["page-header"]} container`}>
            <MyVikatanHeader showMenu={true} showBanner={true} />
            {/* <div className={`${styles["header-section"]} container`}>
              <div>
                <a href="/myvikatan" className={styles["link"]}>
                  <Icon type="home" className={styles["home-icon"]} />
                  <span className={styles["myvikatan-text"]}>#MyVikatan</span>
                </a>
              </div>
              <div className={styles["myvikatan-logo"]}>
                <a href="/myvikatan" className={styles["link"]}>
                  <Icon type="my-vikatan-logo" className={styles["myvikatan-icon"]} />
                </a>
              </div>
            </div>
            <div className={styles["manotravels-Powered"]}>
              Powered by:
              <a href="https://www.manohartravels.com/" rel="noopener noreferrer" target="_blank">
                <img
                  src="https://images.assettype.com/vikatan/2025-05-28/tc2uus4z/mlogo.webp"
                  className={styles["mlogo"]}
                />
              </a>
            </div> */}
          </div>
          <div
            className={
              sectionSlug === "cricket-world-cup-2023" ? styles["cricket-collection"] : styles["first-collection"]
            }
          >
            <WrappedFourStoryOneAdOneWidget
              showReadmore={false}
              accentColor={sectionColor}
              collection={{ ...this.props.data.collection, items: initialStories.slice(0, 21) }}
              pagetype="section"
            />
          </div>
          <LoadMoreCollectionStories
            template={wrapForLoadMore(TweleStoriesCollection, 12)}
            collectionSlug={this.props.data.collection.slug}
            data={Object.assign(
              {},
              { collection: this.props.data.collection },
              { stories: [...initialStories.map(({ story }) => story).slice(0, 24)] },
              { storiesPerPage: 12 }
            )}
            numStoriesToLoad={12}
            params={{ "item-type": "story" }}
          />
        </div>

        <div />
        <VikatanSticky placement="bundle" />
        <VikatanDesktopSticky placement="bundle" />
      </div>
    );
  }
}

MyVikatanPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    section: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    }),
    parentSection: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    })
  }),
  config: PropTypes.shape({}),
  pageType: PropTypes.string
};
